"use strict";

$(document).ready(function () {
  var quickLinksEl = document.querySelector(".floating-quick-links");
  if (!quickLinksEl) {
    return;
  }
  var r = document.querySelector(":root");
  var topOffset = document.querySelector("header.header").offsetHeight;
  if (topOffset > 0) {
    topOffset += 14; // offset requires gap due to box-shadow of quick links
    quickLinksEl.style.setProperty("--floating-quick-links-top", topOffset + 'px');
  }
});